import { useSessionContext } from '@users/session/SessionContext';
import IconSparkleGradient from '@creditflowresearch/uilib/Icon/IconSparkleGradient';
import styles from './askAiChat.module.scss';

const SUGGESTED_PROMPTS = [
  { emoji: '📊', label: 'Largest deals this year' },
  { emoji: '📈', label: 'Tightest spread 10Y Deals' },
  { emoji: '💲', label: 'Split-rated Bonds' },
];

interface IZeroCaseProps {
  onPrompt: (prompt: string) => void,
}

const ZeroCase = ({ onPrompt }: IZeroCaseProps) => {
  const { currentUser } = useSessionContext();

  return (
    <div className={ styles.zeroCase } data-test="askAiChatZeroCase">
      <IconSparkleGradient className={ styles.zeroCaseIcon } />
      <h2 className={ styles.zeroCaseGreeting }>
        Hello{ currentUser?.firstName ? `, ${ currentUser.firstName }` : '' }
      </h2>
      <p className={ styles.zeroCaseText }>
        CreditFlow AI is ready to help with your analytics questions!
        Keep in mind that I specialize in analytics-related topics.
      </p>
      <div className={ styles.zeroCasePrompts }>
        { SUGGESTED_PROMPTS.map(({ emoji, label }) => (
          <button
            key={ label }
            type="button"
            className={ styles.promptTag }
            onClick={ () => onPrompt(label) }
            data-test="askAiChatSuggestedPrompt"
          >
            <span aria-hidden>{ emoji }</span>
            <span className={ styles.promptTagLabel }>{ label }</span>
          </button>
        )) }
      </div>
    </div>
  );
};

export default ZeroCase;
